import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as SW from './switch-account.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule
	],
	declarations: [
		SW.SwitchAccountComponent,
		SW.SwitchAccountDialog
	],
	exports: [
		SW.SwitchAccountComponent,
		SW.SwitchAccountDialog
	]
})
export class SwitchAccountComponentModule { }

